import React from 'react';

import { IPageContext } from 'common/interfaces/pagecontext.interface';

import Facebook from './icons/facebook.svg';
import Linkedin from './icons/linkedin.svg';
import Twitter from './icons/twitter.svg';
import Instagram from './icons/instagram.svg';
import { FacebookUrl, LinkedinUrl, TwitterUrl, InstagramUrl, ClutchWidgetUrl } from '../../../../config/constants';
import LinkTo from '../link/Link';

interface Props {
  pageContext: IPageContext;
}

const Footer = ({ pageContext }: Props) => {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-item terms">
          <p>&copy; {new Date().getFullYear()} Itransition</p>
        </div>
        <div className="footer-item social">
          <ul className="footer-navigation">
            <li className="footer-social-item">
              <a target="_blank" rel="noopener noreferrer" href={FacebookUrl}>
                <Facebook />
              </a>
            </li>
            <li className="footer-social-item">
              <a target="_blank" rel="noopener noreferrer" href={LinkedinUrl}>
                <Linkedin />
              </a>
            </li>
            <li className="footer-social-item">
              <a target="_blank" rel="noopener noreferrer" href={TwitterUrl}>
                <Twitter />
              </a>
            </li>
            <li className="footer-social-item">
              <a target="_blank" rel="noopener noreferrer" href={InstagramUrl}>
                <Instagram />
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-item navigation">
          <ul className="footer-navigation">
            <li className="footer-navigation-item">
              <LinkTo className="footer-navigation-link" pageContext={pageContext} to="/privacy-cookies-policy">
                Itransition recruitment privacy statement
              </LinkTo>
            </li>
          </ul>
        </div>
        <div className="footer-item-clutch footer-item">
          <iframe title="rating" height="40px" width="133px" src={ClutchWidgetUrl} loading="lazy" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
